<template>
	<div class="info">
		<div class="tit">
			{{i18n('302')}}
		</div>
		<div class="ye">
			<div class="left">
				{{i18n('303')}}:
			</div>
			<div class="right">
				{{userInfo.balance || 0}}
			</div>
		</div>
		<div class="czJr">
			<div class="left">
				{{i18n('304')}} :
			</div>
			<div class="right">
				<div :class="(seleIndex==index && type==1)?'item itemAc':'item'" v-for="(item,index) in listData"
					:key="index" @click="sele(index)">
					<div class="one">
						<span>₱</span>{{item.cz}}
					</div>
					<div class="two">
						{{i18n('305')}}
					</div>
					<div class="three">
						{{item.zs}}₱
					</div>
				</div>
			</div>
		</div>
		<div class="zdy">
			<div class="left">
				{{i18n('306')}} :
			</div>
			<div class="right">
				<input type="number" v-model="zdy" :placeholder="i18n('307')" @focus="focusAc" @input="zdyChange">
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getBalance
	} from "@/api/user.js"
	export default {
		name: "info",
		components: {

		},
		data() {
			return {
				zdy: '',
				type: 1,
				seleIndex: 0,
				listData: [{
						cz: '5000',
						zs: '100',
						zg: '5100'
					},
					{
						cz: '10000',
						zs: '300',
						zg: '10300'
					},
					{
						cz: '20000',
						zs: '1000',
						zg: '21000'
					},
					{
						cz: '50000',
						zs: '3000',
						zg: '53000'
					},
					{
						cz: '100000',
						zs: '10000',
						zg: '110000'
					},
					{
						cz: '1000000',
						zs: '120000',
						zg: '1120000'
					}
				]
			}
		},
		methods: {
			async getBalance() {
				let {
					balance
				} = await getBalance()
				this.$store.commit('user/setUserInfo', {
					balance
				})
			},
			sele(index) {
				this.zdy = ""
				this.type = 1
				this.seleIndex = index
				this.$emit("rechargeChange", this.listData[this.seleIndex])
			},
			focusAc() {
				this.type = 2
				this.$emit("rechargeChange", {
					cz: '0',
					zs: '0',
					zg: '0'
				})
			},
			zdyChange(e) {
				this.type = 2
				if (e.detail.value > 10000000) {
					this.zdy = 10000000
				}
				this.$emit("rechargeChange", {
					cz: this.zdy,
					zs: 0,
					zg: this.zdy
				})
			},
		},
		computed: {
			userInfo() {
				return this.$store.state.user.userInfo
			},
		},
		created() {
			this.getBalance()
			this.$emit("rechargeChange", this.listData[this.seleIndex])
		},
		mounted() {

		}
	};
</script>

<style scoped>
	.zdy {
		width: 984px;
		margin: 0 auto;
		border-top: 1px solid rgba(241, 241, 241, 1);
		padding-top: 24px;
		display: flex;
		align-items: center;
	}

	.zdy .right input {
		width: 630px;
		height: 54px;
		background: rgba(86, 171, 123, 0.06);
		border: 0.5px solid rgba(86, 171, 123, 1);
		border-radius: 6px;
		padding: 0 10px;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #000000;
		font-weight: 400;
		box-sizing: border-box;
	}

	.ye {
		display: flex;
		align-items: center;
		padding-left: 24px;
		height: 52px;
	}

	.czJr {
		padding-left: 24px;
		display: flex;
		padding-bottom: 18px;
	}

	.ye .left,
	.czJr .left,
	.zdy .left {
		width: 130px;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #86909C;
		font-weight: 400;
	}

	.ye .right {
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #1D2129;
		font-weight: 400;
	}

	.czJr .right {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		align-content: baseline;
		width: 632px;
	}

	.czJr .right .item {
		margin-bottom: 16px;
		width: 200px;
		height: 79px;
		border: 0.5px solid rgba(0, 0, 0, .4);
		border-radius: 6px;
		cursor: pointer;
	}

	.czJr .right .itemAc {
		background: #56AB7B;
		border: 0.5px solid #56AB7B;
	}

	.czJr .right .item .one {
		padding: 8px 0 6px 14px;
		font-family: PingFangSC-Medium;
		font-size: 18px;
		color: #000000;
		font-weight: 500;
	}

	.czJr .right .itemAc .one {
		color: #FFDE52;
	}

	.czJr .right .item .one span {
		font-family: Helvetica;
		font-size: 12px;
		font-weight: 400;
	}

	.czJr .right .item .two {
		font-family: PingFangSC-Regular;
		font-size: 10px;
		color: rgba(0, 0, 0, .6);
		font-weight: 400;
		margin-bottom: 2px;
		padding-left: 14px;
	}

	.czJr .right .itemAc .two {
		color: #fff;
	}

	.czJr .right .item .three {
		font-family: PingFangSC-Regular;
		font-size: 10px;
		color: #56AB7B;
		line-height: 14px;
		font-weight: 400;
		padding-left: 14px;
	}

	.czJr .right .itemAc .three {
		color: #fff;
	}

	.info {
		width: 1032px;
		height: 412px;
		background: #FFFFFF;
		border-radius: 12px;
		position: relative;
		z-index: 10;
	}

	.info .tit {
		width: 100%;
		height: 48px;
		border-bottom: 1px solid #56AB7B;
		padding-left: 24px;
		box-sizing: border-box;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #1D2129;
		font-weight: 500;
		line-height: 48px;
	}
</style>
